import Flex, { type FlexProps } from "@ui-kit/layout/Flex/Flex.web";

type SeatingMainWrapperProps = { useFullScreen?: boolean } & FlexProps;

/**
 * A wrapper that formats the width of certain assigned seating page content:
 * The seating map itself and the navbar content directly above it.
 *
 * On mobile screen sizes or when the event doesn't have a refund policy,
 * The navbar section containing the event's name/date/location should be full-width.
 *
 * On mobile screen sizes, the seating page cart will be hidden and the map should be full-width.
 */
export default function SeatingMainWrapper({
  useFullScreen = false,
  children,
  ...props
}: SeatingMainWrapperProps) {
  return (
    <Flex
      {...props}
      w={{ base: "100%", sm: useFullScreen ? "100%" : "auto" }}
      flex={useFullScreen ? undefined : { base: undefined, sm: "1" }}
      minWidth={0}
    >
      {children}
    </Flex>
  );
}
